module.exports = __webpack_public_path__ + "static/media/schody33 - schody drewniane zabiegowe.b1e68604.jpg";